<div class="modal-header">
    <button type="button" class="close" data-dismiss="modal">×</button>
    <h4 class="modal-title">{{TR "Gruppen freigeben"}}</h4>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col-xs-12">
        <div id="js-email-region"></div>
            {{#if errors.email}}
            <ul class="parsley-errors-list filled">
                <li class="parsley-required">{{errors.email}}</li>
            </ul>
            {{/if}}

        </div>
    </div>
    <div class="row m-t-20">
        <div class="col-xs-12">
            <p>{{TR "Folgende Gruppen werden freigegeben"}}:</p>
            {{#EACH-COLS groups 2 'ct-device-groups'}}
                &#8226;&nbsp;{{name}}
            {{/EACH-COLS}}
        </div>
    </div>
</div>

<div class="modal-footer">
    <button id="ct-cancel" class="btn btn-white" data-dismiss="modal">
        {{TR "Abbrechen"}}
    </button>
    <button class="btn btn-primary" id="js-btn-submit">
        {{TR "Freigeben"}}
    </button>
</div>
